import {
  DatagridConfigurable,
  List,
  TextField,
  SearchInput,
  TopToolbar,
  SelectColumnsButton,
  CreateButton,
  FunctionField,
  Pagination,
} from "react-admin";

import { CLIENT_SEARCH_SOURCE, FILTER_LIMITS } from "@/constants/filters";
import { useCountries } from "@/modules/countries";

const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <CreateButton />
  </TopToolbar>
);

export const CountryPricesList = () => {
  const { data: { countriesObject = {} } = {} } = useCountries();

  return (
    <List
      filters={[
        <SearchInput
          key="search"
          placeholder="Search Country Price"
          source={CLIENT_SEARCH_SOURCE}
          alwaysOn
        />,
      ]}
      actions={<ListActions />}
      pagination={<Pagination rowsPerPageOptions={FILTER_LIMITS} />}
      perPage={FILTER_LIMITS[0]}
      storeKey={false}
    >
      <DatagridConfigurable bulkActionButtons={false}>
        <TextField source="country" label="Code" sortable={false} />
        <FunctionField
          label="Country"
          source="country"
          render={(record: { country: string }) =>
            countriesObject[record.country] || record.country
          }
        />
        <TextField source="trialCost" sortable={false} />
      </DatagridConfigurable>
    </List>
  );
};
